module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tools-tab tools-tab-time"
  }, [_c('table', {
    staticClass: "table table-timepicker equal-padding"
  }, [_c('tr', {
    class: _vm.pause ? 'is-disabled' : ''
  }, [_c('td', {
    class: ['box-hour', _vm.isHour('00') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('00')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('01') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('01')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('02') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('02')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('03') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('03')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('04') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('04')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('05') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('05')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('td', {
    class: ['box-minute', _vm.isMinute('00') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('00')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("00")])]), _vm._v(" "), _c('tr', {
    class: _vm.pause ? 'is-disabled' : ''
  }, [_c('td', {
    class: ['box-hour', _vm.isHour('06') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('06')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('07') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('07')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('08') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('08')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('09') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('09')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('10') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('10')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('11') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('11')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('td', {
    class: ['box-minute', _vm.isMinute('15') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('15')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('tr', {
    class: _vm.pause ? 'is-disabled' : ''
  }, [_c('td', {
    class: ['box-hour', _vm.isHour('12') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('12')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('13') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('13')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('14') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('14')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('15') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('15')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('16') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('16')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('17') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('17')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('td', {
    class: ['box-minute', _vm.isMinute('30') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('30')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('tr', {
    class: _vm.pause ? 'is-disabled' : ''
  }, [_c('td', {
    class: ['box-hour', _vm.isHour('18') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('18')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('19') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('19')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('20') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('20')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('21') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('21')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('22') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('22')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("22")]), _vm._v(" "), _c('td', {
    class: ['box-hour', _vm.isHour('23') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setHour('23')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("23")]), _vm._v(" "), _c('td', {
    class: ['box-minute', _vm.isMinute('45') ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setMinute('45')
      },
      "dblclick": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("45")])]), _vm._v(" "), (_vm.pause) ? _c('tr', {
    staticClass: "break"
  }, [_c('td', {
    staticClass: "box-break",
    on: {
      "click": function($event) {
        _vm.pause = false
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "food"
    }
  })], 1), _vm._v(" "), _c('td', {
    class: ['box-break', (!_vm.form.break) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(0)
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 15) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(15)
      }
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 30) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(30)
      }
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 45) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(45)
      }
    }
  }, [_vm._v("45")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 60) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(60)
      }
    }
  }, [_vm._v("60")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 75) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(75)
      }
    }
  }, [_vm._v("75")]), _vm._v(" "), _c('td', {
    class: ['box-break', (_vm.form.break == 90) ? 'is-active' : ''],
    on: {
      "click": function($event) {
        return _vm.setPause(90)
      }
    }
  }, [_vm._v("90")])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "box-buttons"
  }, [_c('td', {
    on: {
      "click": function($event) {
        return _vm.remove()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "close"
    }
  })], 1), _vm._v(" "), _c('td', {
    class: ['time', (_vm.type == 'from') ? 'is-active' : ''],
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.type = 'from'
      }
    }
  }, [_c('div', {
    class: ['label', _vm.form.from == null ? 'is-big' : '']
  }, [_vm._v(_vm._s(_vm.$t('text.from')))]), _vm._v(" "), (_vm.form.from != null) ? _c('span', [_vm._v(_vm._s(_vm.form.from))]) : _vm._e()]), _vm._v(" "), _c('td', {
    class: ['time', (_vm.type == 'until') ? 'is-active' : ''],
    attrs: {
      "colspan": "2"
    },
    on: {
      "click": function($event) {
        _vm.type = 'until'
      }
    }
  }, [_c('div', {
    class: ['label', _vm.form.until == null ? 'is-big' : '']
  }, [_vm._v(_vm._s(_vm.$t('text.until')))]), _vm._v(" "), (_vm.form.until != null) ? _c('span', [_vm._v(_vm._s(_vm.form.until))]) : _vm._e()]), _vm._v(" "), _c('td', {
    class: ['btn-break', _vm.form.break ? 'has-break' : ''],
    on: {
      "click": function($event) {
        _vm.pause = true;
        _vm.type = 'break'
      }
    }
  }, [(_vm.form.break) ? _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('label.break')))]) : _vm._e(), _vm._v(" "), (_vm.form.break) ? _c('span', [_vm._v(_vm._s(_vm.form.break) + "m")]) : _c('icon', {
    attrs: {
      "name": "food"
    }
  })], 1), _vm._v(" "), _c('td', {
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "check"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ba24b83","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/tools/Times.vue
// module id = 591
// module chunks = 225